/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FavritApp } from './FavritApp';
import {
    FavritAppFromJSON,
    FavritAppFromJSONTyped,
    FavritAppToJSON,
    FavritAppToJSONTyped,
} from './FavritApp';
import type { PaymentProvider } from './PaymentProvider';
import {
    PaymentProviderFromJSON,
    PaymentProviderFromJSONTyped,
    PaymentProviderToJSON,
    PaymentProviderToJSONTyped,
} from './PaymentProvider';
import type { PaymentMethodConnectionActivityStateDto } from './PaymentMethodConnectionActivityStateDto';
import {
    PaymentMethodConnectionActivityStateDtoFromJSON,
    PaymentMethodConnectionActivityStateDtoFromJSONTyped,
    PaymentMethodConnectionActivityStateDtoToJSON,
    PaymentMethodConnectionActivityStateDtoToJSONTyped,
} from './PaymentMethodConnectionActivityStateDto';
import type { CountryCode } from './CountryCode';
import {
    CountryCodeFromJSON,
    CountryCodeFromJSONTyped,
    CountryCodeToJSON,
    CountryCodeToJSONTyped,
} from './CountryCode';

/**
 * 
 * @export
 * @interface PaymentMethodCountryDto
 */
export interface PaymentMethodCountryDto {
    /**
     * 
     * @type {PaymentMethodConnectionActivityStateDto}
     * @memberof PaymentMethodCountryDto
     */
    activityState: PaymentMethodConnectionActivityStateDto;
    /**
     * 
     * @type {CountryCode}
     * @memberof PaymentMethodCountryDto
     */
    countryCode: CountryCode;
    /**
     * 
     * @type {Set<FavritApp>}
     * @memberof PaymentMethodCountryDto
     */
    defaultEnabledInApps: Set<FavritApp>;
    /**
     * 
     * @type {string}
     * @memberof PaymentMethodCountryDto
     */
    paymentMethod: string;
    /**
     * 
     * @type {PaymentProvider}
     * @memberof PaymentMethodCountryDto
     */
    paymentProvider: PaymentProvider;
    /**
     * 
     * @type {boolean}
     * @memberof PaymentMethodCountryDto
     */
    paymentsEnabled: boolean;
}



/**
 * Check if a given object implements the PaymentMethodCountryDto interface.
 */
export function instanceOfPaymentMethodCountryDto(value: object): value is PaymentMethodCountryDto {
    if (!('activityState' in value) || value['activityState'] === undefined) return false;
    if (!('countryCode' in value) || value['countryCode'] === undefined) return false;
    if (!('defaultEnabledInApps' in value) || value['defaultEnabledInApps'] === undefined) return false;
    if (!('paymentMethod' in value) || value['paymentMethod'] === undefined) return false;
    if (!('paymentProvider' in value) || value['paymentProvider'] === undefined) return false;
    if (!('paymentsEnabled' in value) || value['paymentsEnabled'] === undefined) return false;
    return true;
}

export function PaymentMethodCountryDtoFromJSON(json: any): PaymentMethodCountryDto {
    return PaymentMethodCountryDtoFromJSONTyped(json, false);
}

export function PaymentMethodCountryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentMethodCountryDto {
    if (json == null) {
        return json;
    }
    return {
        
        'activityState': PaymentMethodConnectionActivityStateDtoFromJSON(json['activityState']),
        'countryCode': CountryCodeFromJSON(json['countryCode']),
        'defaultEnabledInApps': (new Set((json['defaultEnabledInApps'] as Array<any>).map(FavritAppFromJSON))),
        'paymentMethod': json['paymentMethod'],
        'paymentProvider': PaymentProviderFromJSON(json['paymentProvider']),
        'paymentsEnabled': json['paymentsEnabled'],
    };
}

export function PaymentMethodCountryDtoToJSON(json: any): PaymentMethodCountryDto {
    return PaymentMethodCountryDtoToJSONTyped(json, false);
}

export function PaymentMethodCountryDtoToJSONTyped(value?: PaymentMethodCountryDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'activityState': PaymentMethodConnectionActivityStateDtoToJSON(value['activityState']),
        'countryCode': CountryCodeToJSON(value['countryCode']),
        'defaultEnabledInApps': (Array.from(value['defaultEnabledInApps'] as Set<any>).map(FavritAppToJSON)),
        'paymentMethod': value['paymentMethod'],
        'paymentProvider': PaymentProviderToJSON(value['paymentProvider']),
        'paymentsEnabled': value['paymentsEnabled'],
    };
}

